import { getLocale } from "../runtime";

const sv_hucountry = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Ungern`
};

const hucountry = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_hucountry(inputs)
	return "huCountry";
};

export { hucountry as "huCountry" };